import React from 'react'

function ResumeHobbies({ classname, position,intrests }) {
    return (
        <>
            <div className={`resumeHobbies ${classname}`}>
                <div className='resumeHobbies-heading'>
                    <p className={`font-bold border-b-2 border-solid mb-2 ${position === 'left' ? 'border-white' : 'border-black'}`}>Interests</p>
                </div>
                <div>
                    {intrests.map((data,idx) => {
                        const {interest} = data
                        return <span key={idx} className='text-xs font-light capitalize'>{interest}</span>
                    }).reduce((prev, curr) => [prev, ', ', curr])}
                </div>
            </div>
        </>
    )
}

export default ResumeHobbies